import { BaseOption, useSelect } from 'admin';
import { MaterialOrigin } from 'api';
import { capitalizeString } from 'ui';

import { AutocompleteField, AutocompleteFieldProps, AutocompleteOption } from '../AutocompleteField/AutocompleteField';

const compareLabelsDescending = (a: BaseOption, b: BaseOption) => b.label.localeCompare(a.label);

export const MaterialOriginAutocomplete = (props: Omit<AutocompleteFieldProps<AutocompleteOption>, 'options'>) => {
  const { options: materialOriginOptions } = useSelect<MaterialOrigin>({
    dataProviderName: 'materials',
    optionLabel: (option) => capitalizeString(option.type),
    optionValue: 'id',
    resource: `/v1/material-origins/`,
  });

  return (
    <AutocompleteField<AutocompleteOption> options={materialOriginOptions.sort(compareLabelsDescending)} {...props} />
  );
};
